// Author YuJiaBei
// Date 2020-11-10 11:33:21

class SithMesPrdRoutingSummary {
constructor({
        id = null,
        materialRoutingNo = '',
        materialCode = '',
        materialDescription = '',
        materialType = '',
        ctrlKey = '',
        sapChangedFlag = '',
        stat = '',
        usa = '',
        remark = ''}
= {}) {
    this.id = id;
    this.materialRoutingNo = materialRoutingNo;
    this.materialCode = materialCode;
    this.materialDescription = materialDescription;
    this.materialType = materialType;
    this.ctrlKey = ctrlKey;
    this.sapChangedFlag = sapChangedFlag;
    this.stat = stat;
    this.usa = usa;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdRoutingSummary();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialRoutingNo',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.materialRoutingNo',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialCode',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.materialCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialDescription',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.materialDescription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'materialType',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.materialType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ctrlKey',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.ctrlKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'stat',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.stat',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'usa',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.usa',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sapChangedFlag',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.sapChangedFlag',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '未变化' },
                            { value: '1', text: '从未释放到已释放' },
                            { value: '2', text: '关键信息变更' },
                            { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    codeFilter : "",
    materialCodeFilter : "",
    materialDescriptionFilter : "",
    materialTypeFilter : "",
    ctrlKeyFilter : "",
    sapChangedFlagFilter : "",
    statFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'materialCodeFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.filter.materialCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'materialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.filter.materialDescription',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'materialTypeFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.filter.materialType',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ctrlKeyFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.filter.ctrlKey',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sapChangedFlagFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.filter.sapChangedFlag',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '未变化' },
                { value: '1', text: '从未释放到已释放' },
                { value: '2', text: '关键信息变更' },
                { value: '3', text: '删除' }
            ]
        }
        },
        {
        key: 'statFilter',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.filter.stat',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'materialRoutingNo',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.entity.materialRoutingNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'materialCode',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'materialDescription',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.entity.materialDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'materialType',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.entity.materialType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ctrlKey',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.entity.ctrlKey',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'stat',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.entity.stat',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'usa',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.entity.usa',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdRoutingSummary.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdRoutingSummary, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
